import React, { useState, useEffect } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [scrolling, setScrolling] = useState(false); // To track if user is scrolling

  // Function to handle scroll events
  const handleScroll = () => {
    const scrollPosition = window.scrollY; // Get current scroll position
    if (scrollPosition > 100) { // Adjust the scroll position value as per your need
      setScrolling(true); // If scrolled down more than 100px, set scrolling to true
    } else {
      setScrolling(false); // If scrolled up, reset scrolling to false
    }
  };

  // Add event listener on component mount and clean up on unmount
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  // const toggleSearch = () => {
  //   setIsSearchOpen(!isSearchOpen);
  // };

  return (
    <header className={`header ${scrolling ? 'sticky-header' : ''}`}>
      {/* Header Top */}
      <div className="header-top darkkcolor py-3 ">
        <div className="container">
          <div className="row justify-content-center justify-content-xl-between align-items-center">
            <div className="col-auto">
              <div className="header-top-contact">
                <ul className='anchor d-md-flex'>
                  <li className='px-md-5 fw-bold text-white '>
                    <a href="tel:+918956322311  text-white  " className='text-white fw-bold'>
                      <i className="fas fa-phone-volume text-white"></i> +91 8956322311
                    </a>
                  </li>
                  <li className='px-md-5 fw-bold'>
                    <a href="tel:+918421773700" className='text-white fw-bold'>
                      <i className="fas fa-phone-volume text-white"></i> +91 8421773700
                    </a>
                  </li>
                  <li>
                    <a href="mailto:info@wallabieswarmcares.com" className='text-white'>
                      <i className="far fa-envelope"></i>
                      <span className='fw-bold text-white'> info@wallabieswarmcares.com</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="main-navigation">
        <Navbar expand="lg">
          <Container>
            <img src="/images/logo.jpg" className=' img-fluid  d-block d-md-none' alt="logo" />
            <img src="/images/logo1.jpg" className=' img-fluid  d-none d-md-block' alt="logo" />
            <Navbar.Toggle aria-controls="main_nav" onClick={toggleNav}>
              <i className="fas fa-bars darkcolor"></i> {/* Mobile Menu Icon */}
            </Navbar.Toggle>

            <Navbar.Collapse id="main_nav" className={isNavOpen ? "show" : ""}>
              <Nav className="mx-auto">
                <Nav.Link href="/" className='fw-bold nav-item'>Home</Nav.Link>
                <NavDropdown title="About Us" id="about-us-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/about" className='fw-bold nav-item'>About Us</NavDropdown.Item>
                  <NavDropdown.Item href="/term-condition" className='fw-bold nav-item'>Term & Condition</NavDropdown.Item>
                  <NavDropdown.Item href="/privacy-policy" className='fw-bold '>Privacy Policy</NavDropdown.Item>
                </NavDropdown>
                <Nav.Link href="/Patient-thermoregulation-system" className='fw-bold nav-item'>Patient Thermoregulation</Nav.Link>
                <NavDropdown title="Products" id="about-us-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/Wallabies-Forced-Air-Patient-Warming-Unit" className='fw-bold nav-item'>Wallabies Forced Air Patient Warming Unit</NavDropdown.Item>
                  <NavDropdown.Item href="/wallabies-forced-air-patient-warming-blanket" className='fw-bold nav-item'>Warm Air Blankets</NavDropdown.Item>
                </NavDropdown>
                <Nav.Link href="/Clean-room" className='fw-bold nav-item'> Clean&nbsp;Room</Nav.Link>
                <NavDropdown title="Gallery" id="about-us-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/Photos" className='fw-bold nav-item'>Photos</NavDropdown.Item>
                  <NavDropdown.Item href="/Videos" className='fw-bold '>Videos</NavDropdown.Item>
                </NavDropdown>

                  <NavDropdown title="Download Center" id="about-us-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/Download-Brochure" className='fw-bold nav-item'>Download Center</NavDropdown.Item>
                  <NavDropdown.Item href="\images\Wallabies-Warmcare-Booklet.pdf" className='fw-bold '>Download Booklet</NavDropdown.Item>
                </NavDropdown>


              
              
                <NavDropdown title="Contact Us" id="contact-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/contact-us" className='fw-bold nav-item'>Contact Us</NavDropdown.Item>
                  <NavDropdown.Item href="/enquiry" className='fw-bold'>Enquiry</NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>

      {/* Search Area */}
      {isSearchOpen && (
        <div className="search-area">
          <form action="#">
            <div className="form-group">
              <input type="text" className="form-control" placeholder="Type Keyword..." />
              <button type="submit" className="search-icon-btn">
                <i className="far fa-search"></i>
              </button>
            </div>
          </form>
        </div>
      )}
    </header>
  );
};

export default Header;






